import { Link } from "react-router";
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { useGetTasksQuery } from "../../api/tareas/tareaApi";
import { parseTaskDate } from "../../utils/calendarUtils";
import { CircularProgress } from "@mui/joy";

export function TaskList() {
    const { data: calendarInfo, isLoading } = useGetTasksQuery(undefined, { refetchOnMountOrArgChange: true });

    if(isLoading)
        return (
            <div className="h-full w-full flex justify-center items-center">
                <CircularProgress />
            </div>
        );

    return (
        <div className="h-full overflow-auto">
            {calendarInfo == undefined || calendarInfo.tareas.length == 0
            ?
            <div className="w-full">
                <p className="text-center py-4 text-2xl font-semibold">No hay tareas registradas</p>
            </div>
            : <div>
                <table className="w-full">
                    <thead>
                        <tr>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Titulo
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Descripcion
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Inicia
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Termina
                            </th>
                            <th className="border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                Empresa
                            </th>
                            <th className="w-10 border border-gray-400 h-[10px] py-[4px] px-[8px] text-center text-[14px] font-semibold text-[#111827]">
                                <SettingsRoundedIcon sx={{ height: 17, width: 17, color: "#111827" }}/>
                            </th>
                        </tr>
                    </thead>

                    <tbody className="text-[14px]">
                        {calendarInfo?.tareas.map((tarea, index) => (
                        <tr key={index}>
                            <td className="border h-[10px] py-[4px] px-[8px] text-[14px] font-medium">
                                {tarea.titulo}
                            </td>
                            <td className="border h-[10px] py-[4px] px-[8px] text-[14px] font-semibold">
                                {tarea.descripcion}
                            </td>
                            <td className="border h-[10px] py-[4px] px-[8px] text-[14px] font-semibold text-center">
                                {parseTaskDate(tarea.fechaInicial, tarea.horaInicial)}
                            </td>
                            <td className="border h-[10px] py-[4px] px-[8px] text-[14px] font-semibold text-center">
                                {parseTaskDate(tarea.fechaFinal, tarea.horaFinal)}
                            </td>
                            <td className="border h-[10px] py-[4px] px-[8px] text-[14px] font-semibold">
                                {tarea.empresaName}
                            </td>
                            <td className="text-center border h-[10px] py-[4px] px-[8px] text-[14px] font-semibold">
                                <Link to={`/calendario/${tarea.id}`}>Detalles</Link>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            }
        </div>
    );
}